<mat-toolbar color="primary">
  <img
    class="logo-img"
    [ngSrc]="logoAssets.imgSrc"
    [width]="38"
    [height]="38"
    [alt]="logoAssets.altImg"
    priority="high"
  />
  <span class="app-name">{{ appName }}</span>

  <span class="spacer"></span>

  <sans-play-toolbar-links
    class="toolbar-links"
    [gamePlayId]="gamePlayId"
  ></sans-play-toolbar-links>

  <div class="hamburger-menu">
    <sans-play-hamburger-menu [gamePlayId]="gamePlayId">
    </sans-play-hamburger-menu>
  </div>
</mat-toolbar>
